<template>
  <div class="partner-detail">
    <el-card class="mb15" v-loading="loadingForm">
      <div slot="header" class="clearfix" style="line-height: 28px">
        <span class="fl">二级合伙人信息</span>
        <div class="fr"><el-button size="mini" type="link" @click="$router.go(-1)">返回</el-button></div>
      </div>
      <el-form :inline="true" size="mini" :label-position="'right'" label-width="120px">
        <el-form-item label="二级合伙人名称">
          <div class="w200">{{ form.name }}</div>
        </el-form-item>
        <el-form-item label="电话">
          <div class="w200">{{ form.phoneNumber }}</div>
        </el-form-item>
        <el-form-item label="加盟日期">
          <div class="w200">{{ form.createTime }}</div>
        </el-form-item>
        <el-form-item label="状态">
          <div class="w200">{{ form.state === 0 ? '有效' : (form.state === 1 ? '无效' : '') }}</div>
        </el-form-item>
        <el-form-item label="会员总数">
          <div class="w200">{{ form.panelCount }}</div>
        </el-form-item>
        <el-form-item label="关注会员总数">
          <div class="w200">{{ form.panelFocusCount }}</div>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="mb15">
      <div class="opreationBox mb15">
        <el-form
          size="mini"
          :inline="true"
          :model="params"
          label-width="140px"
          class="demo-form-inline"
          @submit.native.prevent
        >
          <!--        <el-form-item label="二级合伙人编号">-->
          <!--          <el-input placeholder="请输入" clearable v-model="params.code" />-->
          <!--        </el-form-item>-->
          <el-form-item label="会员名称">
            <el-input placeholder="请输入" clearable v-model="params.panelName" />
          </el-form-item>
          <el-form-item label="会员生效状态">
            <el-select
              clearable
              placeholder="全部"
              v-model="params.panelSate"
            >
              <el-option
                v-for="item in stateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button style="width:98px" type="primary" @click="search">查 询</el-button>
            <el-button style="width:98px" type="danger" plain @click="reset">重 置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tableBox">
        <el-table
          border
          size="mini"
          :data="data"
          v-loading="loading"
          style="width: 100%"
        >
          <!--        <el-table-column label="会员编号" align="center" prop="code" />-->
          <el-table-column label="会员微信名" align="center" prop="nickName" />
          <el-table-column label="会员名称" align="center" prop="name" />
          <el-table-column label="会员生效状态" align="center" prop="panelSate">
            <template slot-scope="scope">
              {{ scope.row.panelSate === 0 ? '有效' : ( scope.row.state === 1 ? '无效' : '') }}
            </template>
          </el-table-column>
          <el-table-column label="电话" align="center" prop="parentPhone" />
          <el-table-column label="注册日期" align="center" prop="createTime" />
          <el-table-column label="公众号状态" align="center" prop="panelCount">
            <template slot-scope="scope">
              <span v-text="scope.row.isSubscribe ? '已关注': '未关注'" :style="{color:scope.row.isSubscribe?'#67c23a':'#f56c6c'}" />
            </template>
          </el-table-column>
          <el-table-column label="二级合伙人名称" align="center" prop="parentName" />
          <el-table-column label="已领取总金额" align="center" prop="received" />
          <el-table-column label="未领取总金额" align="center" prop="unReceived" />
        </el-table>
      </div>
      <div class="pageBox" style="margin-top: 10px;width: 100%;text-align: right;">
        <el-pagination
          background
          @size-change="partnerSizeChange"
          @current-change="partnerCurrentChange"
          :current-page="params.pageIndex"
          :page-sizes="[2, 4, 10, 20, 50, 100]"
          :page-size="params.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { managerPartner as getDetail, managerEnterpriseMemberPanelList as getList } from 'api/request'
  export default {
    name: 'PartnerDetail',
    data() {
      return {
        loadingForm: false,
        form: {},
        loading: false,
        id: this.$route.query.id,
        params: {
          partnerId:  this.$route.query.id,
          pageIndex: 1,
          pageSize: 10,
          panelName: undefined,
          panelSate: undefined
        },
        total: 0,
        data: [],
        stateList: [
          { value: '0', label: '有效' },
          { value: '1', label: '无效' }
        ],
      }
    },
    mounted() {
      this.getDetail()
      this.getList()
    },
    methods: {
      async getDetail() {
        this.loadingForm = true
        const id = this.id
        const res = await getDetail({ id })
        if (res) {
          this.form = res
        }
        this.loadingForm = false
      },
      async getList() {
        this.loading = true
        const res = await getList(this.params)
        if (res) {
          const { rows, total } = res
          console.log(rows)
          this.data = Array.isArray(rows) ? rows : []
          this.total = total && total > 0 ? total : 0
        }
        this.loading = false
      },
      partnerSizeChange(val) {
        this.params.pageSize = val
        this.getList()
      },
      partnerCurrentChange(val) {
        this.params.pageIndex = val
        this.getList()
      },
      search() {
        this.params.pageIndex = 1
        this.getList()
      },
      reset() {
        Object.assign(this.$data.params, this.$options.data().params)
        this.getList()
      },
    }
  }
</script>

<style scoped lang="scss">
  .partner-detail{
    /deep/.el-card__header{
      padding: 5px 20px;
    }
    .clearfix {
      &:after {
        content: "";
        display: table;
        clear: both;
      }
    }
    .fl{
      float: left;
    }
    .fr{
      float: right;
    }
    .mb15{
      margin-bottom: 15px;
    }
    .el-form{
      .el-form-item{
        margin-bottom: 0;
      }
    }
    .w200{
      width: 200px;
    }
  }
</style>
